import Vue from 'vue'

export default {
  setMyCourses(state, payload) {
    state.myCourses = payload
  },
  setLoadingMyCourses(state, payload) {
    state.loadingMyCourses = payload
  },
  setLibraryCourses(state, payload) {
    state.libraryCourses = payload
  },
  setLoadingLibraryCourses(state, payload) {
    state.loadingLibraryCourses = payload
  },
  setCurrentCourse(state, payload) {
    state.currentCourse = payload
  },
  setLoadingCurrentCourse(state, payload) {
    state.loadingCurrentCourse = payload
  },
  setCurrentCourseParticipants(state, payload) {
    state.currentCourseParticipants = payload
  },
  setCurrentCourseAssignmentStatus(state, payload) {
    state.currentCourseAssignmentStatus = payload
  },
  setLoadingCurrentCourseParticipants(state, payload) {
    state.loadingCurrentCourseParticipants = payload
  },
  setCurrentCourseSteps(state, payload) {
    state.currentCourseSteps = payload
  },
  setLoadingCurrentCourseSteps(state, payload) {
    state.loadingCurrentCourseSteps = payload
  },
  setCurrentCourseStep(state, payload) {
    state.currentCourseStep = payload
  },
  setLoadingCurrentCourseStep(state, payload) {
    state.loadingCurrentCourseStep = payload
  },
  setVisibilityStatusOfCourse(state, payload) {
    const { visibilityStatus, id, courseType } = payload
    if (!(visibilityStatus && id && courseType)) {
      return
    }

    let courseTypeStateName = ''
    if (courseType === 'MY_COURSES') {
      courseTypeStateName = 'myCourses'
    } else if (courseType === 'LIBRARY') {
      courseTypeStateName = 'libraryCourses'
    }

    if (courseTypeStateName === '') {
      return
    }

    const courses = [...state[courseTypeStateName]]
    const courseIndex = courses.findIndex(el => el.id === id) ?? -1

    if (courseIndex !== -1) {
      courses[courseIndex].visibilityStatus = visibilityStatus
    }

    state[courseTypeStateName] = [...courses]
    // Vue.set(state, courseTypeStateName, [...courses])
  },
}
